<template>
    <div class="gallery__items">
        <gallery :images="images" :index="index" @close="index = null"></gallery>

        <div class="gallery__row">
            <div v-for="(column, columnIndex) in columnsArray" class="gallery__col" :key="columnIndex">
                <div  :key="image.index" v-bind:id="`i-${image.index}`" v-for="image in columnsArray[columnIndex]" class="gallery__image-container gallery__image-container--loading">
                <img class="gallery__image"
                    v-bind:data-img="`i-${image.index}`"
                    :key="image.index"
                    @click="index = image.index"
                    v-bind:src="image.src"
                    v-on:load="opacityImage"
                />
                </div>

            </div>
        </div>
  </div>
</template>
<script>
import VueGallery from "vue-gallery";
import Logo from "../assets/img/home-bg.jpg";

export default {
  data: function() {
    return {
      index: null,
      columnsArray: [],
    };
  },
  components: {
    gallery: VueGallery,
  },
  mounted: function() {
    this.divideImages(4);
  },
  computed: {
    imagesPerColumn: function() {
      return Math.ceil(this.images.length / 4);
    },
    images: function() {
      const imageArray = [];
      for (let i = 1; i <= 15; i++) {
        imageArray.push(require(`../assets/img/gallery/gallery${i}.jpg`));
      }
      return imageArray;
    },
  },
  methods: {
    divideImages: function(columnNumber) {
      let allColumns = [];
      let columnsCounter = 0;

      for (let i = 0; i < this.images.length; i++) {
        if (!allColumns[columnsCounter]) {
          allColumns.push([{ src: this.images[i], index: i }]);
        } else {
          allColumns[columnsCounter].push({ src: this.images[i], index: i });
        }

        columnsCounter === columnNumber - 1
          ? (columnsCounter = 0)
          : columnsCounter++;
      }

      this.columnsArray = allColumns;
    },

    getImages: function(imageAmount) {
      const imageArray = [];
      for (let i = 1; i <= imageAmount; i++) {
        imageArray.push(require(`../assets/img/gallery/gallery${i}.jpg`));
      }
      return imageArray;
    },

    opacityImage: function(ev) {
      const container = document.querySelector(`#${ev.target.dataset.img}`);
      container.classList.remove("gallery__image-container--loading");
      ev.target.style.opacity = "1";
    },
  },
};
</script>